




















































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class CountriesForm extends Vue {
    loading = true
    data: {[key: string]: unknown} = {}

    cardTitle = ''

    buttonLoading = false

    formData: {[key: string]: any} = {
        typeId: {
            id: null
        },
        countryEnabled: true
    }

    formValid = false
    formRules = {
        required: [
            (v: string) => !!v || 'This field is required'
        ],
        countryName: [
            (v: string) => !!v || 'This field is required',
            (v: string) => (v && v.length <= 50) || 'Field must be less than 50 characters'
        ],
        countryShort: [
            (v: string) => {
                if (v) {
                    return (v.length <= 10) || 'Field must be less than 10 characters'
                } else {
                    return true
                }
            }
        ],
        countryCurrency: [
            (v: string) => !!v || 'This field is required',
            (v: string) => (v && v.length <= 32) || 'Field must be less than 32 characters'
        ]
    }

    formModel: {[key: string]: object[]} = {
        roleTypes: []
    }

    mounted () {
        if (!this.$route.params.action) {
            this.$store.commit('reportError', { code: 1000, message: 'Error, not action sended in route params :(' })
            return
        }
        switch (this.$route.params.action) {
        case 'edit':
            this.cardTitle = 'Edit Country'
            this.getData()
            break
        case 'add':
            this.cardTitle = 'Create Country'
            this.data = {}
            this.loading = false
            break
        }
    }

    getData () {
        this.loading = true
        if (!this.$route.params.id) {
            this.$store.commit('reportError', { code: 1000, message: 'Error, not id sended in route params :(' })
            this.loading = false
            return
        }
        this.$store.dispatch('getCountriesById', this.$route.params.id)
            .then(resp => {
                if (resp?.status === 200) {
                    this.formData = this.$store.state.CountriesStore.countryForm
                    this.loading = false
                }
            })
    }

    async validateForm () {
        await (this.$refs.form as Vue & { validate: () => boolean }).validate()
        if (!this.formValid) return

        this.buttonLoading = true

        switch (this.$route.params.action) {
        case 'edit':
            this.$store.dispatch('editCountries', this.formData)
                .then(resp => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.$router.push({
                            name: 'Countries'
                        }).then(() => {
                            this.buttonLoading = false
                        })
                    }
                })
            break
        case 'add':
            this.$store.dispatch('createCountries', this.formData)
                .then(resp => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.$router.push({
                            name: 'Countries'
                        }).then(() => {
                            this.buttonLoading = false
                        })
                    }
                })
            break
        }
    }

    getDateFormat (dateString: string) {
        const date = new Date(dateString)
        const day = date.getDate().toString().padStart(2, '0')
        const month = date.getMonth().toString().padStart(2, '0')
        const year = date.getFullYear().toString().padStart(4, '0')
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        return `${day}/${month}/${year} - ${hours}:${minutes}`
    }
}
